module.exports = __webpack_public_path__ + "static/radiowa_filharmonia-87e332a914f6a082935ab14f3d21ea66.jpg";